import { Identity } from '@/classes/models'

export default class Invoice {
  /**
   * Create new invoice and set properties based on the given object.
   *
   * @param {Object} obj
   */
  constructor (obj) {
    Object.assign(this, obj)

    // Map billing identity to Identity
    if (typeof this.billingIdentity !== 'undefined') {
      this.billingIdentity = new Identity(this.billingIdentity)
    }
  }

  /**
   * @return {Date}
   */
  get dateTimeUtc () {
    return this._dateTimeUtc
  }

  /**
   * @param {string} value
   */
  set dateTimeUtc (value) {
    this._dateTimeUtc = new Date(value)
  }
}
